// extracted by mini-css-extract-plugin
export default {"creditbtn":"netbank_creditbtn__yfwqc","nbselect":"netbank_nbselect__j5uan"};